import { Badge } from '@/components/ui/badge'
import type { SyncRunStatus, IdPConnectionStatus } from '@/types/uas'

const syncStatusConfig: Record<SyncRunStatus, { variant: 'default' | 'secondary' | 'destructive' | 'outline'; label: string }> = {
  PENDING: { variant: 'outline', label: 'Pending' },
  RUNNING: { variant: 'secondary', label: 'Running' },
  COMPLETED: { variant: 'default', label: 'Completed' },
  COMPLETED_WITH_ERRORS: { variant: 'secondary', label: 'Completed (errors)' },
  FAILED: { variant: 'destructive', label: 'Failed' },
  CANCELLED: { variant: 'outline', label: 'Cancelled' },
}

export function SyncStatusBadge({ status }: { readonly status: SyncRunStatus }) {
  const config = syncStatusConfig[status] ?? { variant: 'outline' as const, label: status }
  return <Badge variant={config.variant}>{config.label}</Badge>
}

const connectionStatusConfig: Record<IdPConnectionStatus, { variant: 'default' | 'secondary' | 'destructive' | 'outline'; label: string }> = {
  CONFIGURED: { variant: 'outline', label: 'Configured' },
  TESTING: { variant: 'secondary', label: 'Testing' },
  CONNECTED: { variant: 'default', label: 'Connected' },
  FAILED: { variant: 'destructive', label: 'Failed' },
  SYNCING: { variant: 'secondary', label: 'Syncing' },
  DISABLED: { variant: 'outline', label: 'Disabled' },
}

export function ConnectionStatusBadge({ status }: { readonly status: IdPConnectionStatus }) {
  const config = connectionStatusConfig[status] ?? { variant: 'outline' as const, label: status }
  return <Badge variant={config.variant}>{config.label}</Badge>
}
